import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const MultiSelectBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M14.6693 5.02323H8.66927V6.35656H14.6693V5.02323ZM14.6693 10.3566H8.66927V11.6899H14.6693V10.3566ZM3.69594 7.6899L1.33594 5.3299L2.27594 4.3899L3.68927 5.80323L6.51594 2.97656L7.45594 3.91656L3.69594 7.6899ZM3.69594 13.0232L1.33594 10.6632L2.27594 9.72323L3.68927 11.1366L6.51594 8.3099L7.45594 9.2499L3.69594 13.0232Z"
      fill="currentColor"
    />
  </IconContainer>
);
